import * as React from 'react'
import { IControlProps } from './types'
import { formatDate } from '../../utils/dates'
import { parseISO, isValid } from 'date-fns'
import { GRID_CELLPADDING, GRID_CELLFONTSIZE } from './grids/consts'
import { CONFIG } from '../../config'
import DateTimePicker from '../common/DateTimePicker'

export interface IAntdDateControlState {
  value: any
}

export default class AntdDateControl extends React.Component<
  IControlProps,
  IAntdDateControlState
> {
  dateFormat: string
  constructor(props: IControlProps) {
    super(props)
    this.handleChange = this.handleChange.bind(this)
    if (props.dateFormat) {
      // eslint-disable-next-line no-useless-escape
      this.dateFormat = props.dateFormat.replace(/\'/gi, '')
    } else {
      this.dateFormat = CONFIG.displayDateFormat
    }
    const initialValue = this.fromStoredValue(this.props.field.value || '')
    if (initialValue == '') {
      this.state = {
        value: null
      }
    } else {
      this.state = {
        value: initialValue
      }
    }
  }

  fromStoredValue(value: string) {
    return value ? parseISO(value) : ''
  }

  toStoredValue(value: string | null) {
    return value ? formatDate('iso_dateonly', value) : ''
  }

  handleChange(date: any) {
    if (date !== null && isValid(date)) {
      this.props.form.setFieldValue(
        this.props.field.name,
        this.toStoredValue(date)
      )
    } else {
      this.props.form.setFieldValue(
        this.props.field.name,
        this.toStoredValue(null)
      )
    }
    this.setState({ value: date })
  }

  render() {
    if (this.props.gridCell) {
      const value = this.fromStoredValue(this.props.field.value || '')

      const displayValue = value
        ? formatDate('display_date', value, this.dateFormat)
        : ''

      return (
        <div
          id={this.props.id}
          style={{ padding: GRID_CELLPADDING, fontSize: GRID_CELLFONTSIZE }}
        >
          {displayValue}
        </div>
      )
    } else {
      return (
        <DateTimePicker
          id={this.props.id}
          value={this.state.value as Date}
          onChange={(date) => this.handleChange(date)}
          displayFormat={this.dateFormat}
          style={{
            borderRadius: '4px',
            boxSizing: 'border-box',
            marginTop: '20px'
          }}
          size='large'
          disabled={this.props.disabled}
          inputReadOnly={true}
        />
      )
    }
  }
}
